import React from "react";
import { ServicesFooter } from "./services-footer"

/**
 * Componente para mostrar el servicio Tecnología en Marketing.
 *
 * @component
 * 
 */

export const TecnologiaMarketing = (props) => {
    const [width, setWidth] = React.useState(window.innerWidth);
    const breakpoint = 620;
  
    React.useEffect(() => {
        /* Inside of a "useEffect" hook add an event listener that updates
        the "width" state variable when the window size changes */
        window.addEventListener("resize", () => setWidth(window.innerWidth));
  
        /* passing an empty array as the dependencies of the effect will cause this
        effect to only run when the component mounts, and not each time it updates.
        We only want the listener to be added once */
    }, []);

  return (
    <div id="service-detail" className="text-center">
        <div className="col-md-8 col-md-offset-2 col-xs-12 section-title">
            <h2><span className="title">Servicios</span></h2>
        </div>
        <div className="col-md-12 col-xs-12 imgMain paddingRightLeft0 text-right">
            <img alt="Tecnologia En Marketing" src={width < breakpoint ? "/img/services/TecnologiaEnMarketing/TecnologiaEnMark_img1_mob.webp" : "/img/services/TecnologiaEnMarketing/TecnologiaEnMark_img1.webp"}></img>
            <div className="text-left titleService">
                <p>Tecnología <br></br>en Marketing</p>
            </div>
        </div>
        {width < breakpoint ? 
            <div>
                <div className="col-md-12 col-xs-12 paddingRightLeft0">
                    <div className="col-md-1 col-xs-1 paddingRightLeft0"></div>
                    <div className="col-md-12 col-xs-12">
                        <div className="col-md-9 paddingRightLeft0 text-analisisdato-img3">
                            <span>Combinamos nuestra experiencia en medios y marketing con el poder de la tecnología para impulsar el crecimiento y el éxito de nuestros clientes.</span>
                            <br></br><br></br>
                        </div>
                    </div>
                    <div className="col-md-6 col-xs-9 col-xs-offset-3 paddingRightLeft0">
                        <img alt="Tecnologia En Marketing" src="/img/services/TecnologiaEnMarketing/TecnologiaEnMark_img2.webp"></img>
                    </div>
                    <div className="col-md-3 col-xs-8 col-xs-offset-2 text-right text-tecnologiamarketing-img1 flex-text-end">
                        <br></br>
                        <span>Desde la implementación y configuración de herramientas tecnológicas hasta la integración de sistemas, automatización de marketing, análisis de datos avanzados y más.</span>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-xs-12">
                            <div className="col-md-1 col-xs-1">&nbsp;</div>
                        </div>
                        <div className="col-md-12 col-xs-12">
                            <div className="col-md-12 col-xs-12">
                                <div className="col-md-12 col-xs-12">
                                    <div className="col-md-1"></div>
                                    <div className="col-md-6 col-xs-12 paddingRightLeft0 visible-md visible-lg">
                                        <img alt="Tecnologia En Marketing" src="/img/services/TecnologiaEnMarketing/TecnologiaEnMark_img3.webp"></img>
                                    </div>
                                    <div className="col-md-5 col-xs-12 text-left text-tecnologiamarketing-img2 paddingRightLeft0">
                                        <span>Comienza a experimentar un aumento significativo en la eficiencia operativa, una mayor precisión en la segmentación de audiencias, una optimización de la experiencia del cliente y un retorno de la inversión medible y sólido.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            :
            <div className="container-fluid padding-fluid">
                <div className="row">
                    <div className="col-md-12 col-xs-12">
                        <div className="col-md-1 col-xs-1">&nbsp;</div>
                    </div>
                    <div className="col-md-12 col-xs-12">
                        <div className="col-md-12 col-xs-12">
                            <div className="col-md-12 col-xs-12">
                                <div className="col-md-3">
                                    &nbsp;
                                </div>
                                <div className="col-md-9 text-analisisdato-img3 paddingRightLeft2">
                                    <span>Combinamos nuestra experiencia en medios y marketing con el poder de la tecnología para impulsar el crecimiento y el éxito de nuestros clientes.</span>
                                    <br></br><br></br>
                                </div>
                            </div>
                            <div className="col-md-12 col-xs-12 flex paddingRightLeft0">
                                <div className="col-md-3 text-right text-tecnologiamarketing-img1 flex-text-end paddingRightLeft0">
                                    <span>Desde la implementación y configuración de herramientas tecnológicas hasta la integración de sistemas, automatización de marketing, análisis de datos avanzados y más.</span>
                                </div>
                                <div className="col-md-8 text-left">
                                    <img alt="Tecnologia En Marketing" src="/img/services/TecnologiaEnMarketing/TecnologiaEnMark_img2.webp"></img>
                                </div>
                            </div>
                            <div className="col-md-12 col-xs-12 paddingRightLeft0 flex padding">
                                {/* <div className="col-md-1"></div> */}
                                <div className="col-md-6 col-xs-12 paddingRightLeft0">
                                    <img alt="Tecnologia En Marketing" src="/img/services/TecnologiaEnMarketing/TecnologiaEnMark_img3.webp"></img>
                                </div>
                                <div className="col-md-6 col-xs-12 text-left text-tecnologiamarketing-img2 flex-text-end">
                                    <span>Comienza a experimentar un aumento significativo en la eficiencia operativa, una mayor precisión en la segmentación de audiencias, una optimización de la experiencia del cliente y un retorno de la inversión medible y sólido.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ServicesFooter data={props.data} id={4} />
            </div>
        }
    </div>
  );
};
